import { render, staticRenderFns } from "./ConfirmDeletion.vue?vue&type=template&id=db9dd73a&scoped=true&"
import script from "./ConfirmDeletion.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeletion.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDeletion.vue?vue&type=style&index=0&id=db9dd73a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9dd73a",
  null
  
)

export default component.exports